import * as  React from 'react';
import device from '../../../services/mini/device';
import { ReactChildrenGeneralType } from '../../../models/ReactChildrenGeneralType';

type PopupWrapperProps = {
    className: string;
    children: ReactChildrenGeneralType;
    style?: object;
}

export default function PopupWrapper({ className, style, children }: PopupWrapperProps) {
    return <div
        className={`popup-form ${!device.isDesktop() ? 'mobile' : ''} ${className}`}
        style={style}>
        {children}
    </div>;
}
